import PropTypes from 'prop-types';

import { gettext, translationPropType } from '@eb/i18n-ebspa';

import { HEADER_IMAGES_PROPTYPES } from './header';
import {
    ONLINE_BANNER_URL,
    TLD_AUSTRALIA,
    TLD_CANADA,
    TLD_GLOBALLY,
    TLD_IRELAND,
    TLD_MEXICO,
    TLD_UNITED_KINGDOM,
    TLD_UNITED_STATES,
    TLD_NEW_ZEALAND,
} from './constants';

const BEST_UK_AND_IRELAND_EVENTS =
    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F116773365%2F252646217916%2F1%2Foriginal.20201104-172231?w=1024&auto=format%2Ccompress&q=75&sharp=10&s=fb26280a9407521a865dddf2a78fb9dc';

const IN_PERSON_EVENTS_AU_NZ =
    'https://cdn.evbstatic.com/s3-build/perm_001/4b4dd7/django/images/homefeed/header-AU-NZ.jpg';

const CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES = {
    collectionLink:
        'https://www.eventbrite.com/c/the-best-online-events-to-attend-right-from-your-home-cwwqhpk/',
    collectionPrefix: 'cwwqhpk',
    shouldShowCustomHeader: true,
    customHeaderPriority: 1000,
};

export const SEASONAL_CONTENT = {
    default: {
        coronavirus: {
            startDate: {
                day: 18,
                month: 3,
                year: 2020,
            },
            endDate: {
                day: 18,
                month: 3,
                year: 2220,
            },
            key: 'coronavirus',
            tlds: [TLD_GLOBALLY],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: true,
            alwaysShow: true,
            customHeaderPriority: 0,
            // NB: Location-specific overrides take precedent over tldOverrides
            tldOverrides: {
                [TLD_NEW_ZEALAND]: {
                    startDate: {
                        day: 1,
                        month: 12,
                        year: 2020,
                    },
                    endDate: {
                        day: 5,
                        month: 10,
                        year: 2021,
                    },
                    collectionLink: '/d/new-zealand/events/',
                    headerImages: {
                        mobile: IN_PERSON_EVENTS_AU_NZ,
                        tablet: IN_PERSON_EVENTS_AU_NZ,
                        desktop: IN_PERSON_EVENTS_AU_NZ,
                        twok: IN_PERSON_EVENTS_AU_NZ,
                    },
                    // no gettext since shown in English-speaking TLDs only
                    combinedHeaderTitleAndCta:
                        '<div class="feed-header__title-top">Explore the best</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">local events.</div>',
                },
                [TLD_AUSTRALIA]: {
                    startDate: {
                        day: 1,
                        month: 12,
                        year: 2020,
                    },
                    endDate: {
                        day: 5,
                        month: 10,
                        year: 2021,
                    },
                    collectionLink: '/d/australia/events/',
                    headerImages: {
                        mobile: IN_PERSON_EVENTS_AU_NZ,
                        tablet: IN_PERSON_EVENTS_AU_NZ,
                        desktop: IN_PERSON_EVENTS_AU_NZ,
                        twok: IN_PERSON_EVENTS_AU_NZ,
                    },
                    // no gettext since shown in English-speaking TLDs only
                    combinedHeaderTitleAndCta:
                        '<div class="feed-header__title-top">Explore the best</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">local events.</div>',
                },
                [TLD_UNITED_KINGDOM]: {
                    startDate: {
                        day: 1,
                        month: 12,
                        year: 2020,
                    },
                    endDate: {
                        day: 5,
                        month: 10,
                        year: 2021,
                    },
                    collectionLink: '/c/best-online-events-uk-ireland-cwxygxg/',
                    headerImages: {
                        mobile: BEST_UK_AND_IRELAND_EVENTS,
                        tablet: BEST_UK_AND_IRELAND_EVENTS,
                        desktop: BEST_UK_AND_IRELAND_EVENTS,
                        twok: BEST_UK_AND_IRELAND_EVENTS,
                    },
                    // no gettext since shown in English-speaking TLDs only
                    combinedHeaderTitleAndCta:
                        '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
                },
                [TLD_IRELAND]: {
                    startDate: {
                        day: 1,
                        month: 12,
                        year: 2020,
                    },
                    endDate: {
                        day: 5,
                        month: 10,
                        year: 2021,
                    },
                    collectionLink: '/c/best-online-events-uk-ireland-cwxygxg/',
                    headerImages: {
                        mobile: BEST_UK_AND_IRELAND_EVENTS,
                        tablet: BEST_UK_AND_IRELAND_EVENTS,
                        desktop: BEST_UK_AND_IRELAND_EVENTS,
                        twok: BEST_UK_AND_IRELAND_EVENTS,
                    },
                    // no gettext since shown in English-speaking TLDs only
                    combinedHeaderTitleAndCta:
                        '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
                },
            },
        },
        // TODO: Document this part better
        waitangiDay: {
            key: 'waitangiDay ',
            tabName: 'Waitangi Day',
            eventSearchQ: gettext('Waitangi Day'),
            startDate: {
                day: 18,
                month: 1,
            },
            endDate: {
                day: 7,
                month: 2,
            },
            tlds: [TLD_NEW_ZEALAND],
            tldsExcluded: [TLD_MEXICO],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
        australiaDay: {
            key: 'australiaDay ',
            tabName: 'Australia Day',
            eventSearchQ: gettext('Australia day'),
            startDate: {
                day: 11,
                month: 1,
            },
            endDate: {
                day: 27,
                month: 1,
            },
            tlds: [TLD_AUSTRALIA],
            tldsExcluded: [TLD_MEXICO],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
        chineseNewYearAU: {
            key: 'chineseNewYear ',
            tabName: 'Chinese new year',
            eventSearchQ: gettext('Chinese new year lunar new year'),
            startDate: {
                day: 1,
                month: 2,
            },
            endDate: {
                day: 13,
                month: 2,
            },
            tlds: [TLD_AUSTRALIA, TLD_NEW_ZEALAND],
            tldsExcluded: [TLD_MEXICO],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
        chineseNewYearUS: {
            key: 'chineseNewYear ',
            tabName: 'Chinese new year',
            eventSearchQ: gettext('Chinese new year lunar new year'),
            startDate: {
                day: 20,
                month: 1,
            },
            endDate: {
                day: 13,
                month: 2,
            },
            tlds: [
                TLD_UNITED_STATES,
                TLD_CANADA,
                TLD_UNITED_KINGDOM,
                TLD_IRELAND,
            ],
            tldsExcluded: [TLD_MEXICO],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
        valentinesDay: {
            key: 'valentinesDay ',
            tabName: "Valentine's Day",
            eventSearchQ: gettext("valentine's day valentine"),
            startDate: {
                day: 23,
                month: 1,
            },
            endDate: {
                day: 15,
                month: 2,
            },
            tlds: [
                TLD_UNITED_STATES,
                TLD_CANADA,
                TLD_AUSTRALIA,
                TLD_NEW_ZEALAND,
                TLD_UNITED_KINGDOM,
                TLD_IRELAND,
            ],
            tldsExcluded: [TLD_MEXICO],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
        womensMarch: {
            key: 'womensMarch',
            tabName: "Women's march",
            eventSearchQ: gettext("Women's march"),
            startDate: {
                day: 1,
                month: 1,
                year: 2021,
            },
            endDate: {
                day: 1,
                month: 2,
                year: 2021,
            },
            tlds: [TLD_UNITED_STATES],
            tldsExcluded: [TLD_MEXICO],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
        halloween: {
            key: 'halloween',
            tabName: 'Halloween',
            eventSearchQ: gettext('Halloween day of the dead'),
            startDate: {
                day: 1,
                month: 10,
            },
            endDate: {
                day: 1,
                month: 11,
            },
            tlds: [
                TLD_UNITED_STATES,
                TLD_AUSTRALIA,
                TLD_UNITED_KINGDOM,
                TLD_IRELAND,
                TLD_CANADA,
                TLD_NEW_ZEALAND,
            ],
            tldsExcluded: [TLD_MEXICO],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
        breastCancer: {
            key: 'breastCancer',
            tabName: 'Breast Cancer Awareness',
            eventSearchQ: gettext('Breast Cancer'),
            startDate: {
                day: 1,
                month: 10,
            },
            endDate: {
                day: 1,
                month: 11,
            },
            tlds: [TLD_UNITED_STATES],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
        holidayEvents: {
            key: 'holidayEvents',
            tabName: 'Holiday events',
            eventSearchQ: gettext(
                'holiday christmas hannukah light show channukah kwanza three kings festivus bodhi day',
            ),
            startDate: {
                day: 1,
                month: 12,
                year: 2020,
            },
            endDate: {
                day: 5,
                month: 1,
                year: 2021,
            },
            tlds: [TLD_UNITED_STATES, TLD_AUSTRALIA, TLD_NEW_ZEALAND],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
        holidayEventsUK: {
            key: 'holidayEventsUK',
            tabName: 'Christmas & Festivities',
            eventSearchQ: gettext(
                'wreath making christmas market santa grotto light festival night market',
            ),
            startDate: {
                day: 1,
                month: 12,
                year: 2020,
            },
            endDate: {
                day: 5,
                month: 1,
                year: 2021,
            },
            tlds: [TLD_UNITED_KINGDOM],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
        holidayEventsIE: {
            key: 'holidayEventsIE',
            tabName: 'Christmas & Festivities',
            eventSearchQ: gettext(
                'christmas market santa grotto wreath making',
            ),
            startDate: {
                day: 1,
                month: 12,
                year: 2020,
            },
            endDate: {
                day: 5,
                month: 1,
                year: 2021,
            },
            tlds: [TLD_IRELAND],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
        veteransDayUS: {
            key: 'veteransDayUS',
            tabName: "Veteran's Day",
            eventSearchQ: gettext("Veteran's Day"),
            startDate: {
                day: 20,
                month: 10,
            },
            endDate: {
                day: 12,
                month: 11,
            },
            tlds: [TLD_UNITED_STATES],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
        melbourneCup: {
            key: 'melbourneCup',
            tabName: 'Melbourne Cup',
            eventSearchQ: gettext('Melbourne cup'),
            startDate: {
                day: 23,
                month: 10,
            },
            endDate: {
                day: 5,
                month: 11,
            },
            tlds: [TLD_AUSTRALIA],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
        blackHistory: {
            key: 'blackHistoryUK',
            tabName: 'Black History Month',
            eventSearchQ: gettext('black history culture'),
            startDate: {
                day: 1,
                month: 10,
            },
            endDate: {
                day: 1,
                month: 11,
            },
            tlds: [TLD_UNITED_KINGDOM],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
        diwali: {
            key: 'diwali',
            tabName: 'Diwali',
            eventSearchQ: gettext('Diwali'),
            startDate: {
                day: 1,
                month: 11,
            },
            endDate: {
                day: 16,
                month: 11,
            },
            tlds: [TLD_UNITED_STATES],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
        thanksgiving: {
            key: 'thanksgiving',
            tabName: 'Thanksgiving',
            eventSearchQ: gettext(
                'Thankgiving turkey volunteer turkey day turkey trot',
            ),
            startDate: {
                day: 5,
                month: 11,
            },
            endDate: {
                day: 28,
                month: 11,
            },
            tlds: [TLD_UNITED_STATES],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
        NYE: {
            key: 'NYE',
            tabName: gettext("New Year's"),
            eventSearchQ: gettext("NYE New Year's Eve New Year"),
            startDate: {
                day: 10,
                month: 12,
                year: 2020,
            },
            endDate: {
                day: 5,
                month: 1,
                year: 2021,
            },
            tlds: [
                TLD_UNITED_STATES,
                TLD_UNITED_KINGDOM,
                TLD_CANADA,
                TLD_IRELAND,
                TLD_AUSTRALIA,
                TLD_NEW_ZEALAND,
            ],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: true,
            alwaysShow: false,
        },
        mothersDay: {
            key: 'mothersDay',
            tabName: gettext("Mother's day"),
            eventSearchQ: gettext("mother's day"),
            onlineOnly: true,
            startDate: {
                day: 8,
                month: 5,
            },
            endDate: {
                day: 11,
                month: 5,
            },
            tlds: [TLD_GLOBALLY],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: true,
            alwaysShow: false,
        },
        pride: {
            key: 'pride',
            tabName: gettext('Pride'),
            eventSearchQ: gettext('pride'),
            onlineOnly: false,
            startDate: {
                day: 28,
                month: 5,
                year: 2020,
            },
            endDate: {
                day: 30,
                month: 6,
                year: 2020,
            },
            tlds: [TLD_GLOBALLY],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: true,
            alwaysShow: false,
        },
        fathersDay: {
            key: 'fathersDay',
            tabName: gettext("Father's Day"),
            eventSearchQ: gettext("Father's Day Dad dad's day"),
            onlineOnly: false,
            startDate: {
                day: 16,
                month: 6,
                year: 2020,
            },
            endDate: {
                day: 21,
                month: 6,
                year: 2020,
            },
            tlds: [TLD_GLOBALLY],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: true,
            customHeaderPriority: 0,
            alwaysShow: false,
        },
        julyFourth: {
            key: 'julyFourth',
            tabName: gettext('4 of July'),
            eventSearchQ: gettext(
                'July 4 4th of July Independence Day fireworks',
            ),
            onlineOnly: false,
            startDate: {
                day: 22,
                month: 6,
                year: 2020,
            },
            endDate: {
                day: 5,
                month: 7,
                year: 2020,
            },
            tlds: [TLD_GLOBALLY],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
        laborDay: {
            key: 'laborDay',
            tabName: gettext('Labor day'),
            eventSearchQ: gettext('labor day'),
            onlineOnly: false,
            startDate: {
                day: 21,
                month: 8,
            },
            endDate: {
                day: 7,
                month: 9,
            },
            tlds: [TLD_UNITED_STATES, TLD_CANADA],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
    },
    // NB: Location-specific settings here override tldOverrides
    // New York
    '85977539': {
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        fathersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        laborDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        halloween: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
    },
    // San Francisco
    '85922583': {
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        fathersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        laborDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        halloween: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
    },
    // Los Angeles
    '85923517': {
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        fathersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        laborDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        halloween: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
    },
    // Washington DC
    '85931779': {
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        fathersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        laborDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        halloween: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
    },
    // Chicago
    '85940195': {
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        fathersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        laborDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        halloween: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
    },
    // Philadelphia
    '101718083': {
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        fathersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        laborDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        halloween: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
    },
    // Atlanta
    '85936429': {
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        fathersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        laborDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        halloween: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
    },
};

export const BASE_SEASONAL_CONTENT_PROPTYPES = {
    byDate: PropTypes.shape({
        key: PropTypes.string,
        startDate: PropTypes.shape({
            day: PropTypes.number,
            month: PropTypes.number,
        }),
        endDate: PropTypes.shape({
            day: PropTypes.number,
            month: PropTypes.number,
        }),
        eventSearchQ: translationPropType,
        onlineOnly: PropTypes.bool,
        forceDisable: PropTypes.bool,
        headerImages: PropTypes.shape(HEADER_IMAGES_PROPTYPES),
        attribution: PropTypes.string,
        cta: PropTypes.string,
        linkLabel: translationPropType,
    }),
    byPlace: PropTypes.shape({
        collectionLink: PropTypes.string,
        collectionPrefix: PropTypes.string,
        shouldShowCustomHeader: PropTypes.bool,
        customHeaderPriority: PropTypes.number,
    }),
};
